import { mapGetters } from 'vuex';

function getTitle(vm) {
  const { title } = vm.$options;
  if (title) {
    return typeof title === 'function'
      ? title.call(vm)
      : title;
  }
}

export default {
  computed: {
    ...mapGetters({
      setting: 'setting/get_setting',
    }),
  },
  created() {
    const title = getTitle(this);
    console.log('test', this.setting.setting.company_name);

    if (title) {
      const siteName = (this.setting) ? this.setting.setting.company_name : '';
      document.title = title + (siteName ? ' | ' + siteName : '');
    }
  },
  watch: {
    // Fires reliably when the namespaced getter resolves from API
    setting(newSetting) {

      const title = getTitle(this);
      if (title && newSetting && newSetting.company_name) {
        document.title = title + ' | ' + newSetting.company_name;
      }
    },
  },
};
